var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter } from '@angular/core';
import { RemaxMarker } from '../../../../../classes/remax-marker';
import { CustomMarker, NguiMap, NguiMapComponent } from '@ngui/map';
var PlainMarkerComponent = /** @class */ (function (_super) {
    __extends(PlainMarkerComponent, _super);
    function PlainMarkerComponent(nguiMapComponent, elementRef, nguiMap) {
        var _this = _super.call(this, nguiMapComponent, elementRef, nguiMap) || this;
        _this.onClickMarker = new EventEmitter();
        return _this;
    }
    return PlainMarkerComponent;
}(CustomMarker));
export { PlainMarkerComponent };
